import React from "react";
import { LiveChatUser } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { MediaConstraints, MediaDevicePermissions, UserListItemIcon } from "types";
import MediaSettings from "./components/MediaSettings";
import TextChat from "./components/TextChat";
import UserList from "./components/UserList";
import "./style.scss";

export enum RightPanelView {
  HIDE_ALL,
  CHAT,
  USERS,
  SETTINGS,
}

interface Props {
  loading: boolean;
  token: string;
  threadId?: string;
  userList: LiveChatUser[];
  devices?: { audioInputs: MediaDeviceInfo[]; videoInputs: MediaDeviceInfo[] };
  onChangeConstraints?: (constraints: MediaConstraints) => void;
  constraints?: MediaConstraints | null;
  permissions?: MediaDevicePermissions;
  changeControls: (rightPanelView: RightPanelView) => void;
  showSection: RightPanelView;
  disableAttachments?: boolean;
  userListItemIcon?: UserListItemIcon;
  enableUserSearch?: boolean;
  modalChatView?: boolean;
  includeGuestsList?: boolean;
  allowGuestMessage?: boolean;
  me?: LiveChatUser;
  setHasUnreadMessage: (v: boolean) => void;
}

const RightPanel = ({
  loading,
  token,
  threadId,
  userList,
  devices,
  onChangeConstraints,
  constraints,
  permissions,
  changeControls,
  showSection,
  disableAttachments,
  userListItemIcon,
  enableUserSearch,
  modalChatView,
  includeGuestsList,
  allowGuestMessage,
  me,
  setHasUnreadMessage,
}: Props) => {
  const cls = ["right-panel"];

  return (
    <div className={cls.join(" ")}>
      <TextChat
        threadId={threadId}
        token={token}
        disableAttachments={disableAttachments}
        modalChatView={modalChatView}
        allowGuestMessage={allowGuestMessage}
        me={me}
        className={"right-panel__section __text-chat" + (showSection === RightPanelView.CHAT ? "" : " __hide")}
        onClose={() => changeControls(RightPanelView.HIDE_ALL)}
        setHasUnreadMessage={setHasUnreadMessage}
      />
      {devices && (
        <MediaSettings
          loading={loading}
          audioInputs={devices.audioInputs}
          videoInputs={devices.videoInputs}
          className={"right-panel__section px-3 py-4" + (showSection === RightPanelView.SETTINGS ? "" : " __hide")}
          onChangeConstraints={onChangeConstraints}
          constraints={constraints}
          permissions={permissions}
          onClose={() => changeControls(RightPanelView.HIDE_ALL)}
        />
      )}
      {userList && (
        <UserList
          className={"right-panel__section" + (showSection === RightPanelView.USERS ? "" : " __hide")}
          userList={userList}
          enableSearch={enableUserSearch}
          includeGuests={includeGuestsList}
          userListItemIcon={userListItemIcon}
          onClose={() => changeControls(RightPanelView.HIDE_ALL)}
        />
      )}
    </div>
  );
};

export default RightPanel;
